module.exports = __webpack_public_path__ + "media/fonts/SovremennicWide-Bold-bc467903727e1377598875067f05200b.ttf";